<template>
  <div v-if="isLoading" class="loading">
    <Loader v-if="!isError" />
    <div v-else>
      Doctor Not Found
    </div>
  </div>
  <div v-else>
    <div class="hvh-flex ">
      <FixedPlaceholder class="loading" :component="HCPProfilesLeftMenu" v-model="currentTab" :tabs="tabs" />
      <div class="grow-1 overflow-hidden px-1">
        <div class="hcp-profile-header">
          <div>
            <div class="p-4">
              <h2 class="font-weight-bold mb-4">{{ modelData.firstName + ' ' + modelData.lastName + ', ' + modelData.credential + ' (NPI: ' + modelData.npi + ')' }}</h2>
              <div class="hcp-profile-subheader">
                <div class="subheader-left">
                  <div>
                    <span class="text-muted">Specialty</span>
                  </div>

                  <span>
                    <strong>{{ modelData.specialty }}</strong>
                  </span>

                  <div style="padding-top: 1%">
                    <span class="text-muted">Hospital</span>
                  </div>
                  <div>
                    <span class="text-muted">
                      <strong>{{ modelData.affiliatedHospital.hospitalName || 'Unknown' }}</strong>
                    </span>
                  </div>

                  <div style="padding-top: 1%">
                    <span class="text-muted">Practice Group Name</span>
                  </div>
                  <span class="text-muted">
                    <strong>{{ modelData.practiceGroupName || 'Unknown' }}</strong>
                  </span>

                  <div style="padding-top: 1%">
                    <span class="text-muted">Address</span>
                  </div>
                  <span class="text-muted">
                    <strong>{{ modelData.address + ', ' + modelData.city + ', ' + modelData.state + ' ' + modelData.zip }}</strong>
                  </span>
                </div>
                <div class="subheader-right">
                  <div>
                    <span class="text-muted">IDN Name</span>
                  </div>
                  <div>
                    <span class="text-muted">
                      <strong>{{ modelData.affiliatedHospital.idnName || 'Unknown' }}</strong>
                    </span>
                  </div>
                  
                  <div style="padding-top: 1%">
                    <span style="display: flex;" class="text-muted tooltip-container"  @mouseover="mouseOver" @mouseout="mouseOut">National Importance %ile 
                      <div style="padding-left: 5px;">
                         <strong>What is this?</strong>  
                        </div>
                    </span>
                    
                  </div>
                  <div>
                    <span>
                      <strong>{{ ordinalSuffixOf(modelData.globalPageRankPercentile) }} </strong>
                      
                    </span>
                  </div>

                  <div style="padding-top: 1%">
                    <span style="display: flex;"  class="text-muted tooltip-container"  @mouseover="mouseOver" @mouseout="mouseOut">Specialty Importance %ile 
                      <div style="padding-left: 5px;">
                         <strong>What is this?</strong> <div class="tooltip-text" v-if="hovered" >These "Importance %iles" are proprietary metrics defined based on the referral patterns we see in claims. It is based on the PageRank algorithm, which determines the "importance" of doctors within the referrals graph.  The scores are then converted into percentiles, both on a national basis (all US HCPs) and within each specialty.</div>
                     
                        </div>
                    </span>
                  </div>
                  <div>
                    <span>
                      <strong>{{ ordinalSuffixOf(modelData.specialtyPageRankPercentile) }} </strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <v-card class="hvh-card--rounded top-padding-content">
          <keep-alive>
            <component :is="tabs[currentTab].component" :modelData="modelData[currentTab.camelCase()]" :npi="this.$route.params.npi" :cohortId="this.$route.params.cohortId" :runId="this.$route.params.runId" />
          </keep-alive>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios'
import HCPProfileTrials from '../../../src/components/hcpProfiles/HCPProfileTrials.vue'
// import MediaCommunications from '../../../src/components/hcpProfiles/MediaCommunications.vue'

import HCPProfileClaims from '../../../src/components/hcpProfiles/HCPProfileClaims.vue'
import HCPProfilePracticeGroup from '../../../src/components/hcpProfiles/HCPProfilePracticeGroup.vue'
import HCPSharedPatients from '../../../src/components/hcpProfiles/HCPSharedPatients.vue'
import HCPProfilesLeftMenu from '../../components/hcpProfiles/HCPProfilesLeftMenu.vue'
import FixedPlaceholder from '../../components/common/fixedPlaceholder/FixedPlaceholder.vue'
import { errorDebug } from '../../libraries/common'

// TODO: most similar physicians?
// import Trials from '../../../src/components/hcpProfiles/HCPProfileTrials.vue'
// import Trials from '../../../src/components/hcpProfiles/HCPProfileTrials.vue'
// import SharedPatientNetworks from '../../../src/components/hcpProfiles/HCPNetworks.vue'

export default {
  components: { HCPProfilesLeftMenu, FixedPlaceholder },
  data() {
    return {
      isLoading: true,
      hovered: false,
      isError: false,
      currentComponent: 'PatientCharacteristics',
      profiles: [],
      name: "",
      modelData: null,
      // have a func that sets the currentcomponent to the ID of the clicked list item, replace string with ''
      tabs: {
        'PatientCharacteristics': { 'name': 'Patient Characteristics', 'component': HCPProfileClaims },
        'PracticeGroup': { 'name': 'Practice Group', 'component': HCPProfilePracticeGroup },
        'Trials': { 'name': 'Trials', 'component': HCPProfileTrials },
        // 'PaymentsAndEngagements': { 'name': 'Payments & Engagements', 'component': '' },
        'SharedPatientNetworks': { 'name': 'Shared Patient Networks', 'component': HCPSharedPatients },
        // 'mediaCommunications': { 'name': 'Media Communications', 'component': MediaCommunications },
        // 'SimilarPhysicians': { 'name': 'Similar Physicians', 'component': '' }
      },
      HCPProfilesLeftMenu,
    };

  },
  computed: {
    currentTab: {
      get() {
        var tab = this.$route.params.tab || 'Patient-Characteristics';
        return tab.split('-').join('');
      },
      set(value) {
        if (value !== this.currentTab) {
          var tab = value.splitByUpperCase().join('-');
          this.$router.replace({ name: 'hcpProfileTab', params: { ...this.$route.params, tab } });
        }
      },
    }
  },
  methods: {
    getData() {
      // show loading indicator
      // clear out the model data 
      // this.modelData = null;
      this.isLoading = true;
      this.currentComponent = 'patientCharacteristics';
      axios.get(`/HCPProfiles/${this.$route.params.cohortId}/${this.$route.params.runId}/${this.$route.params.npi}`)
        .then((response) => {
          this.modelData = response.data
          this.isLoading = false
        })
        .catch((er) => {
          errorDebug(er)
          this.isError = true
        }
        );

      // get shared patients info here too ,
      // on cohort filter, only get update the necessary fields 
    },
    ordinalSuffixOf(i) {
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },
    mouseOver() {
            this.hovered = true;   
    },
    mouseOut(){
      this.hovered = false;
    }
  },
  watch: {
    '$route.params.runId'() {
      this.getData()
    },
    '$route.params.npi'() {
      this.getData()
    },
    '$route.params.cohortId'() {
      this.getData()
    },
  },
  mounted() {
    this.getData();
  },
}

</script>
<style lang="scss" scoped>

.loading {
  height: 100vh;
}
.hcp-profile-header {
  background-color: #f3f5f7;
}

.top-padding-content {
  margin-top: 1%;
  margin-bottom: 1%;
}
.hcp-profile-subheader {
  display: flex;
}

.subheader-left {
  flex: 1;
}

.subheader-right {
  flex: 1;
}

.tooltip-container{
  position: relative;
}

.tooltip-text {
  z-index: 1000;
  position: absolute;
  width: 80%;
  top: 100%;  /* Positions the tooltip above the container */
  left: 50%;  /* Start from the center of the container */
  transform: translateX(-50%);  /* Ensures the tooltip is centered above the container */
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
   /* Initially hide the tooltip */
  // opacity: 0;
  transition: opacity 0.3s;
  // white-space: nowrap;  /* Prevents the text inside the tooltip from wrapping */
  pointer-events: none;  /* Ensures that the tooltip does not interfere with mouse events */
}
</style>